// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminSettings_container__136pT","div":"AdminSettings_div__2ZKFM","textBox":"AdminSettings_textBox__2PZi1","notification":"AdminSettings_notification__1_CNc"};